import { TextField } from "@mui/material"

export type TextFieldProps = {
    label : string,
    name? : string;
    value? : any;
    onChange? : (e : any) => void;  
    onBlur? : (e : any) => void;
    required? : boolean;
    error? : boolean;
    helperText? : string;
    type? : string;
    disabled? : boolean;
    maxLength? : number;
    select?: boolean;
    
    customField? : () => JSX.Element;

    maxWidth?: string;
    minWidth?: string;
    width?: string;

    maxHeight?: string;
    minHeight?: string;
    height?: string;

    validators? : ((value? : string) => (string | undefined))[] | undefined 
    
}

export const commonInputStyles = {
    top: 3,
    height: "15px",
    fontSize: "5px !important",
    color: "rgba(0, 0, 0, 0.54)",
    paddingRight: "15px !important",
    paddingLeft: "5px",
    backgroundColor: "white",
    lineHeight: "1rem",
};

export function VivaTextField(props : TextFieldProps) {


    const InputLabelProps = {
        shrink: true,
        style: commonInputStyles,
    }

    const InputProps = {
        style: {
            height: props.height ?? 40,
            minHeight: props.minHeight,
            maxHeight: props.maxHeight,
            width: props.width ?? "20rem",
            minWidth: props.minWidth,
            maxWidth: props.maxWidth ?? "40rem",
        }, 
        inputProps: { maxLength : props.maxLength },
    }

    const FormHelperTextProps = {
        sx: {
        margin: 0.5,
        fontSize: "12px",
        display: "flex",
        alignItems: "center",
        },
    }

    return (
        <>
        { props.customField ? props.customField() :
        <TextField
            InputLabelProps={InputLabelProps}
            InputProps={InputProps}
            FormHelperTextProps={FormHelperTextProps}
            variant="outlined"
            // fullWidth
            name = {props.name}
            value={props.value}
            onChange={props.onChange}
            onBlur={props.onBlur}
            required={props.required}
            error={props.error}
            helperText={props.helperText}
            label={props.label}
            type={props.type}
            disabled={props.disabled}
            select={props.select}

        />
        }
        </>
    )


}